module.exports = __webpack_public_path__ + "img/Discover-card.b504a385.png";